import { j as o } from "./kezios-design-system.esm172.js";
import { IconComponent as n } from "./kezios-design-system.esm4.js";
const s = (r) => /* @__PURE__ */ o.jsxs(n, { ...r, viewBox: "0 0 24 24", fill: "none", children: [
  /* @__PURE__ */ o.jsx("path", { stroke: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ o.jsx(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M12 12c2-2.96 0-7-1-8 0 3.038-1.773 4.741-3 6-1.226 1.26-2 3.24-2 5a6 6 0 1 0 12 0c0-1.532-1.056-3.94-2-5-1.786 3-2.791 3-4 2z"
    }
  )
] });
export {
  s as IconFlame
};
